import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../api";
import { PageSize } from "../../shared/constant";
import Endpoint from "../../shared/endpoints";
import salesDataConstants from "../constants/salesDataContants";
import globalUtils from "../../utils/globalUtils";

// TODO take into params, Change this
const getSalesFileData = (payload: any) => {
  return api.get(
    `${Endpoint.retrieveSalesFiles}/?page=${payload.page}&search=${payload.searchText}&from_date_after=${payload.from}&to_date_before=${payload.to}&page_size=${PageSize.DEFAULT}`,
  );
};

const postSalesFileData = (payload: any) =>
  api.post(Endpoint.createSalesFile, payload);

const getFileColumns = (payload: any) =>
  api.get(`${Endpoint.getFileColumns}/${payload.id}`);

const postSalesDataMapToRawdata = (payload: any) =>
  api.post(Endpoint.createRawData, payload);

const getMasterData = (payload: any) =>
  api.post(
    `${Endpoint.getMasterData}`,
    {
      file_id: payload.file_id,
    },
    {
      params: {
        page: payload.page,
        ...(payload.is_valid_data && { is_valid_data: payload.is_valid_data }),
        ...(payload.search && { search: payload.search }),
        page_size: PageSize.FIFTY,
      },
    },
  );

const editMasterData = (id: string, payload: any) =>
  api.patch(`${Endpoint.editMasterData}/${id}`, payload);

const deleteMasterData = (id: string) =>
  api.delete(`${Endpoint.deleteMasterData}/${id}`);

const processMasterData = (payload: any) =>
  api.post(Endpoint.processMasterData, payload);

const deleteSalesFile = (payload: any) =>
  api.delete(Endpoint.deleteSalesFile, {
    data: payload,
  });

const deleteProcessedFile = (payload: any) =>
  api.delete(`${Endpoint.deleteProcessedFile}/${payload.file_id}/`);

const downloadSalesFile = (payload: any) =>
  api.get(`${Endpoint.downloadSalesFile}/${payload.id}/download`, {
    responseType: "blob",
  });

function* getSalesFiles(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getSalesFileData,
      action.payload,
    );
    yield put({
      type: salesDataConstants.GET_SALES_FILES_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: salesDataConstants.GET_SALES_FILES_FAILURE, err: e });
  }
}

function* postSalesFile(action: any) {
  try {
    const response: AxiosResponse = yield call(
      postSalesFileData,
      action.payload,
    );
    yield put({
      type: salesDataConstants.POST_SALES_FILE_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: salesDataConstants.POST_SALES_FILE_FAILURE, err: e });
  }
}

function* getFileColumnsAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(getFileColumns, action.payload);
    yield put({
      type: salesDataConstants.GET_FILE_COLUMNS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: salesDataConstants.GET_FILE_COLUMNS_FAILURE, err: e });
  }
}

function* mapSalesDataToRawData(action: any) {
  try {
    const response: AxiosResponse = yield call(
      postSalesDataMapToRawdata,
      action.payload,
    );
    yield put({
      type: salesDataConstants.MAP_TO_RAW_DATA_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: salesDataConstants.MAP_TO_RAW_DATA_FAILURE, err: e });
  }
}

function* getMasterDataAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(getMasterData, action.payload);
    yield put({
      type: salesDataConstants.GET_MASTER_DATA_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: salesDataConstants.GET_MASTER_DATA_FAILURE, err: e });
  }
}

function* editMasterDataAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      editMasterData,
      action.id,
      action.payload,
    );
    yield put({
      type: salesDataConstants.EDIT_MASTER_DATA_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: salesDataConstants.EDIT_MASTER_DATA_FAILURE, err: e });
  }
}

function* deleteMasterDataAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(deleteMasterData, action.id);
    yield put({
      type: salesDataConstants.DELETE_MASTER_DATA_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: salesDataConstants.DELETE_MASTER_DATA_FAILURE, err: e });
  }
}

function* processMasterDataAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      processMasterData,
      action.payload,
    );
    yield put({
      type: salesDataConstants.PROCESS_MASTER_DATA_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: salesDataConstants.PROCESS_MASTER_DATA_FAILURE, err: e });
  }
}

function* deleteSalesFileAsync(action: any) {
  try {
    // Extract filterParams from payload before making API call
    const { filterParams, ...deletePayload } = action.payload;
    const response: AxiosResponse = yield call(deleteSalesFile, deletePayload);
    yield put({
      type: salesDataConstants.DELETE_SALES_FILE_SUCCESS,
      payload: response,
    });
    // Refresh sales files after successful delete
    const refreshParams = filterParams || {
      page: 1,
      searchText: "",
      from: "",
      to: "",
    };
    yield put({
      type: salesDataConstants.GET_SALES_FILES_REQUEST,
      payload: refreshParams,
    });
  } catch (e) {
    yield put({ type: salesDataConstants.DELETE_SALES_FILE_FAILURE, err: e });
  }
}

function* deleteProcessedFileAsync(action: any) {
  try {
    // Extract filterParams from payload before making API call
    const { filterParams, ...deletePayload } = action.payload;
    const response: AxiosResponse = yield call(
      deleteProcessedFile,
      deletePayload,
    );
    yield put({
      type: salesDataConstants.DELETE_PROCESSED_FILE_SUCCESS,
      payload: response,
    });
    // Refresh sales files after successful delete
    const refreshParams = filterParams || {
      page: 1,
      searchText: "",
      from: "",
      to: "",
    };
    yield put({
      type: salesDataConstants.GET_SALES_FILES_REQUEST,
      payload: refreshParams,
    });
  } catch (e) {
    yield put({
      type: salesDataConstants.DELETE_PROCESSED_FILE_FAILURE,
      err: e,
    });
  }
}

function* downloadSalesFileAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      downloadSalesFile,
      action.payload,
    );

    globalUtils.download(response.data, action.payload.filename);

    yield put({
      type: salesDataConstants.DOWNLOAD_SALES_FILE_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: salesDataConstants.DOWNLOAD_SALES_FILE_FAILURE, err: e });
  }
}

function* salesDataSaga() {
  yield all([
    takeEvery(salesDataConstants.GET_SALES_FILES_REQUEST, getSalesFiles),
    takeEvery(salesDataConstants.POST_SALES_FILE_REQUEST, postSalesFile),
    takeEvery(salesDataConstants.GET_FILE_COLUMNS_REQUEST, getFileColumnsAsync),
    takeEvery(
      salesDataConstants.MAP_TO_RAW_DATA_REQUEST,
      mapSalesDataToRawData,
    ),
    takeEvery(salesDataConstants.GET_MASTER_DATA_REQUEST, getMasterDataAsync),
    takeEvery(salesDataConstants.EDIT_MASTER_DATA_REQUEST, editMasterDataAsync),
    takeEvery(
      salesDataConstants.DELETE_MASTER_DATA_REQUEST,
      deleteMasterDataAsync,
    ),
    takeEvery(
      salesDataConstants.PROCESS_MASTER_DATA_REQUEST,
      processMasterDataAsync,
    ),
    takeEvery(
      salesDataConstants.DELETE_SALES_FILE_REQUEST,
      deleteSalesFileAsync,
    ),
    takeEvery(
      salesDataConstants.DELETE_PROCESSED_FILE_REQUEST,
      deleteProcessedFileAsync,
    ),
    takeEvery(
      salesDataConstants.DOWNLOAD_SALES_FILE_REQUEST,
      downloadSalesFileAsync,
    ),
  ]);
}

export default salesDataSaga;
